import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import BackgroundLoading from '../assets/background.png';
import SplashLogo from '../assets/splash-logo.png';
import Image from './Image';
import useLocales from '../hooks/useLocales';
import { isSafariOrIOS } from '../utils/isSafariOrIOS';

const SplashScreen = () => {
  const theme = useTheme();
  const { translate } = useLocales();
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        background: isSafariOrIOS ? theme.palette.gradients.theme3Ios : theme.palette.gradients.theme3,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Center container */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
        }}
      >
        {/* Logo */}
        <Image
          src={'favicon/android-chrome-192x192.png'}
          sx={{
            width: 50,
            height: 50,
          }}
        />

        {/* Text */}
        <Box>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: 20,
              lineHeight: 1.5,
              textAlign: 'center',
            }}
          >
            {translate('top_casino')}
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: 'text.secondary',
            }}
          >
            {translate('play_big')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SplashScreen;
